module.exports = __webpack_public_path__ + "src/assets/img/gen-poster.f4e8ee62.png";